import "./../../bindings/bao-tabs";
import "./../../bindings/bao-searcher";
import * as ko from "knockout";
import Bao from "./../../services/bao-service";
import SearchPaging from "./../../factories/search-paging";
import BaoDialog from "./../../factories/bao-dialog";
import TabPage from "./../../factories/tab-page";
import TabController from "./../../factories/tab-controller";
import Device3Assignment from "./device3-assignment";
import Device3Device4Assignment from "./device3-device4-assignment";
import TranslateDialog from "./../../factories/translate-dialog";
function Device3ViewModel(tabPage) {
    var self = this;
    SearchPaging.call(this, tabPage);
    self.TabPage = tabPage;
    self.TabViewModel = new TabController(false);
    self.FormName = ko.observable();
    self.Device3Name = ko.observable();
    self.Device3Name1 = ko.observable();
    self.Device3Name2 = ko.observable();
    self.Device3Name3 = ko.observable();
    self.Device3Name4 = ko.observable();
    self.Device3Name5 = ko.observable();
    self.Description = ko.observable();
    self.Description1 = ko.observable();
    self.Description2 = ko.observable();
    self.Description3 = ko.observable();
    self.Description4 = ko.observable();
    self.Description5 = ko.observable();
    self.Translate = function () {
        var translateDialog = new TranslateDialog(self.Device3Name1, self.Device3Name2, self.Device3Name3, self.Device3Name4, self.Device3Name5);
        translateDialog.Open().then(function () {
        });
    };
    self.Device3NameComputed = ko.computed(function () {
        //nur für "suscriptions"
        if (self != undefined) {
            self.Device3Name1();
            self.Device3Name2();
            self.Device3Name3();
            self.Device3Name4();
            self.Device3Name5();
            switch (Bao.Session.Language.LanguageIndex()) {
                case 1:
                    self.Device3Name(self.Device3Name1());
                    break;
                case 2:
                    self.Device3Name(self.Device3Name2());
                    break;
                case 3:
                    self.Device3Name(self.Device3Name3());
                    break;
                case 4:
                    self.Device3Name(self.Device3Name4());
                    break;
                case 5:
                    self.Device3Name(self.Device3Name5());
                    break;
            }
        }
    });
    self.Device3Name.subscribe(function () {
        switch (Bao.Session.Language.LanguageIndex()) {
            case 1:
                self.Device3Name1(self.Device3Name());
                break;
            case 2:
                self.Device3Name2(self.Device3Name());
                break;
            case 3:
                self.Device3Name3(self.Device3Name());
                break;
            case 4:
                self.Device3Name4(self.Device3Name());
                break;
            case 5:
                self.Device3Name5(self.Device3Name());
                break;
        }
    });
    self.Description.subscribe(function (v) {
        switch (Bao.Session.Language.LanguageIndex()) {
            case 2:
                self.Description2(v);
                break;
            case 3:
                self.Description3(v);
                break;
            case 4:
                self.Description4(v);
                break;
            case 5:
                self.Description5(v);
                break;
            default:
                self.Description1(v);
                break;
        }
    });
    self.loaded = function () {
        this.InitPaging();
        this.TabPage.DirtyFlag.reset();
        this.TabPage.IsLoading(false);
        this.Focus();
        var newTab = new TabPage(null);
        newTab.Url("MasterData/Device3/AssignmentTab");
        newTab.AutoSelect = true;
        newTab.IsClosable(false);
        newTab.PreLoad(true);
        newTab.Visible(true);
        newTab.ViewModel(new Device3Assignment(self.TabPage, self));
        newTab.ViewModel().Refresh();
        newTab["Bao"] = Bao;
        self.TabViewModel.AddTab(newTab);
        var def = $.Deferred();
        Bao.post("Device3/HasSecondAssignment", JSON.stringify({ sessionTabId: self.SessionTabId() })).then(function (result) {
            if (result == "True") {
                var device4Tab = new TabPage(null);
                device4Tab.Url("MasterData/Device3/Device4AssignmentTab");
                device4Tab.AutoSelect = false;
                device4Tab.IsClosable(false);
                device4Tab.PreLoad(true);
                device4Tab.Visible(true);
                device4Tab.ViewModel(new Device3Device4Assignment(self.TabPage, self));
                device4Tab.ViewModel().Refresh();
                device4Tab["Bao"] = Bao;
                self.TabViewModel.AddTab(device4Tab);
            }
        }).then(def.resolve);
        return def.promise();
    };
    self.CompleteCheck = function () {
        var isComplete = true;
        if (Bao.Utils.String.IsNullOrEmpty(self.Device3Name())) {
            isComplete = false;
        }
        if (!isComplete) {
            new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
        }
        return isComplete;
    };
    // Erweiterung des Models zum Server aufgrund array-dirtyFlag-Problem
    self.ExtendModelForSave = function (model) {
    };
    var baseRefresh = self.PerformRefresh;
    self.PerformRefresh = function () {
        var def = $.Deferred();
        baseRefresh.call(self).then(function () {
            Bao.post("Device3/ResetAssignment", JSON.stringify({ sessionTabId: self.SessionTabId() })).then(function () {
                self.TabViewModel.RefreshTabs().then(def.resolve);
            });
        });
        return def.promise();
    };
}
Bao.inherit(Device3ViewModel, SearchPaging);
Device3ViewModel.prototype.PrimaryKey = "Device3Id";
Device3ViewModel.prototype.RefreshUrl = "MasterData/Device3/Get";
Device3ViewModel.prototype.SaveUrl = "MasterData/Device3/Save";
Device3ViewModel.prototype.DeleteUrl = "MasterData/Device3/Delete";
Device3ViewModel.prototype.IsInUseUrl = "MasterData/Device3/IsInUse";
Device3ViewModel.prototype.PermissionForward = "Device3Forward";
Device3ViewModel.prototype.PermissionBackward = "Device3Backward";
Device3ViewModel.prototype.PermissionSave = "Device3Save";
Device3ViewModel.prototype.PermissionRefresh = "Device3Refresh";
Device3ViewModel.prototype.PermissionDelete = "Device3Delete";
export default Device3ViewModel;